import { render, staticRenderFns } from "./Vrainers.vue?vue&type=template&id=366a5d34&scoped=true&"
import script from "./Vrainers.vue?vue&type=script&lang=js&"
export * from "./Vrainers.vue?vue&type=script&lang=js&"
import style0 from "./Vrainers.vue?vue&type=style&index=0&id=366a5d34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366a5d34",
  null
  
)

export default component.exports